// app_enums.js

export const NavigationType = {
  V1: 'Version 1',
  V2: 'Version 2',
  V3: 'Version 3',
  V4: 'Version 4'
};
